import { useStore } from '../core/store';
import { LoadableStatus } from '../mobx-utils';
import { PageLoader } from '@cfm-media/pwa-ui-components';
import { observer } from 'mobx-react-lite';

export const Loader = observer(() => {
  const { BookingStore } = useStore();

  if (BookingStore?.booking?.status === LoadableStatus.loading) {
    return <LoadSpinner />;
  } else if (BookingStore?.booking?.status === LoadableStatus.error) {
    return <div>Error</div>;
  }
});

export function LoadSpinner() {
  return <PageLoader variant="absolute" overlay />;
}
